import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import {Grid, Autoplay, Pagination } from "swiper/modules";
import imgone from '../../Images/aboutone.jpg'
import imgtwo from '../../Images/eventone.jpeg'
import imgthree from '../../Images/eventtwo.jpeg'
import imgfour from '../../Images/eventthree.jpeg'
import { Slide } from 'react-awesome-reveal';
import { NavLink } from 'react-router-dom';
const Homegallery = () => {
  return (
    <>
    <div className="container-fluid mt-5 p-5">
    
      
        <div className="row">
          <div className='col-12 col-md-6 col-lg-4 px-3'>
          <div className="home-page-about-section-details-main-con">
                                    <div className="home-page-about-section-details-con">
                                        <h2>Gallery</h2>
                                        <h3>Our Gallery</h3>
                                        <p style={{textAlign:'justify'}}>With a variety of regional and international meals prepared with fresh ingredients, our dining selections at Seema Resort are sure to please any pallet. Our cosy, welcoming atmosphere guarantees a great dinner, whether you're dining with family or friends. Seema Resort is the ideal option if you're looking for a tranquil yet exciting vacation. Experience the finest of comfort and nature at our resort in Neral by making your reservation today. Our goal is to make your visit one to remember!                                        </p>
                                        
                                        {/* <p style={{textAlign:'justify'}}>Located in the stunning Neral hills, Seema Resort is a tranquil haven that is ideal for anyone looking for a restorative time surrounded by the splendour of nature. Our resort in Nerul is surrounded by thick vegetation and offers a tranquil atmosphere that makes it the perfect place to escape the daily grind. It also boasts stunning views of the Western Ghats. Whether you're looking for adventure, leisure, or time.                                        </p> */}
                                        {/* <p style={{textAlign:'justify'}}>Our resort in Neral provides a range of tastefully decorated apartments and lodgings to suit all kinds of tourists. Modern conveniences in every room provide a relaxing and pleasurable stay. Our resort combines the elegance of modern life with the allure of nature, offering cosy, private rooms as well as roomy suites. Our serene settings and cosy lodgings offer the ideal environment for unwinding after a day of sightseeing.                                        </p> */}
                                        <div className="home-page-about-section-details-btn">
                                          <NavLink to="/family-resort-neral" style={{textDecoration:"none"}}>
                                            <button  className="btn btn-lg btn-dark my-2 mb-4 d-flex" style={{
                                backgroundColor:"black",
                                borderRadius:"0"
                            }}>
                                                Explore More
                                            </button>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
          </div>
          <div className='col-12 col-md-6 col-lg-8 px-3 m=auto'>
          <Slide direction='right'>
         
         <Swiper style={{zIndex:'0'}}
         breakpoints={{
           550: {
             slidesPerView: 1,
           },
           700: {
             slidesPerView: 1,
           },

           1024: {
             slidesPerView: 2,
           },
         }}
           
           spaceBetween={20}
           autoplay={{
               delay: 2500,
               disableOnInteraction: false,
             }}
       
           pagination={{
             clickable: true,
           }}
           modules={[Grid,Pagination,Autoplay]}
           className="mt-5 mySwiper"
         >
           <SwiperSlide className="   mb-5 swiperslideone" >
             <div style={{height:'250px', width:'100%'}}>
               <img src={imgone} alt='img' style={{height:'250px',borderRadius:'24px',width:"100%",objectFit:"cover"}}/>
             </div>
           </SwiperSlide>
           <SwiperSlide className="   mb-5 swiperslideone" >
             <div style={{height:'250px', width:'100%'}}>
               <img src={imgtwo} alt='img' style={{height:'250px',borderRadius:'24px',width:"100%",objectFit:"cover"}}/>
             </div>
           </SwiperSlide>
           <SwiperSlide className="   mb-5 swiperslideone" >
             <div style={{height:'250px', width:'100%'}}>
               <img src={imgthree} alt='img' style={{height:'250px',borderRadius:'24px',width:"100%",objectFit:"cover"}}/>
             </div>
           </SwiperSlide>
           <SwiperSlide className="   mb-5 swiperslideone" >
             <div style={{height:'250px', width:'100%'}}>
               <img src={imgfour} alt='img' style={{height:'250px',borderRadius:'24px',width:"100%",objectFit:"cover"}}/>
             </div>
           </SwiperSlide>
           
          
         </Swiper>
         </Slide>
          </div>

          {/* <h5
            className="text-center pt-5"
            style={{ color: "var(--primary-color)", fontWeight: "bold" }}
          >
            Our Gallery
          </h5> */}
          {/* <h2
            className=" text-center mt-2"
            style={{ fontWeight: "bold",fontFamily:"var(--head-font)",color:'var(--primary-color)',fontSize:'41px',
             
              letterSpacing:'2px' }}
          >
           Our Gallery
          </h2> */}
         
          
          <div className="col-12 col-md-6 col-lg-4 pt-5"></div>
        </div>

       
      </div>
    </>
  )
}

export default Homegallery
